import captureSentryException from '../sentry/captureSentryException';
import tagRecordings from '../hotjar/tagRecordings';

export default function captureRenderBlockingException(e, extras = null) {
  const sentryEnabled = process.env.SENTRY_ENABLED === 'true';
  if (!sentryEnabled) { return; }

  Sentry.withScope((scope) => {
    scope.setTag('render_blocking', true);
    captureSentryException(e, extras);
  });

  tagRecordings(['render_blocking_vue_error']);
}
